export enum AdfoxPlacement {
    VacancyPage = 'vacancyPage',
    ResponseSuccess = 'responseSuccess',
    Profile = 'profile',
    Shifts = 'shifts',
    Main = 'main',
    HalfScreen = 'halfScreen',
    FullScreen = 'fullScreen',
}

export enum AdfoxTapTarget {
    InApp = 'inApp',
    Browser = 'browser',
}

export enum AdfoxCtaButtonStyle {
    Accent = 'accent',
    Contrast = 'contrast',
    Neutral = 'neutral',
}

export enum AdfoxCloseButtonColor {
    Dark = 'dark',
    Light = 'light',
}

export const CLICK_URL_MACRO = '%banner.reference_mrc_user1%';

export interface AdfoxInfoForm {
    placement: AdfoxPlacement;
    tapTarget: AdfoxTapTarget;
    ctaLabel: string;
    ctaButtonStyle: AdfoxCtaButtonStyle;
    closeButtonColor: AdfoxCloseButtonColor;
    openCtaInExternalBrowser: boolean;
    isAdvertising: boolean;
    advertiserName: string;
    advertiserInn: string;
    erid: string;
}

export const ADFOX_PLACEMENTS: AdfoxPlacement[] = [
    AdfoxPlacement.VacancyPage,
    AdfoxPlacement.ResponseSuccess,
    AdfoxPlacement.Profile,
    AdfoxPlacement.Shifts,
    AdfoxPlacement.Main,
    AdfoxPlacement.HalfScreen,
    AdfoxPlacement.FullScreen,
];

export const isPromoPlacement = (placement: AdfoxPlacement): boolean =>
    placement === AdfoxPlacement.HalfScreen || placement === AdfoxPlacement.FullScreen;

export const isBrowserTapAllowed = (placement: AdfoxPlacement): boolean =>
    !isPromoPlacement(placement) && placement !== AdfoxPlacement.Shifts;

export const DEFAULT_ADFOX_INFO_FORM: AdfoxInfoForm = {
    placement: AdfoxPlacement.VacancyPage,
    tapTarget: AdfoxTapTarget.InApp,
    ctaLabel: '',
    ctaButtonStyle: AdfoxCtaButtonStyle.Accent,
    closeButtonColor: AdfoxCloseButtonColor.Light,
    openCtaInExternalBrowser: false,
    isAdvertising: false,
    advertiserName: '',
    advertiserInn: '',
    erid: '',
};
